module.exports = __webpack_public_path__ + "static/media/gen_fir_con_ass.0fc13833.png";